export default {
  empty_list: 'Nessuna categoria ancora',
  uses_restaurant_open_times: 'Utilizza gli orari di apertura del ristorante',
  products_creation_disabled:
    "A causa dell'integrazione attiva con {{integration}}, la creazione di nuovi prodotti non è consentita. Per modificare il menu, apportare le modifiche in {{integration}} e sincronizzare il menu.",
  buttons: {
    add_category: 'Aggiungi categoria',
  },
  toasts: {
    something_went_wrong: 'Qualcosa è andato storto',
  },
};
